import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { injectable } from "tsyringe";
import { ApiDocumentInjection } from "features/apiDocumentFeature/di/ApiDocumentInjection";
import { ApiDocumentRequestEntity } from "../entities/ApiDocumentRequestEntity";
import { ApiDocumentResponseEntity } from "../entities/ApiDocumentResponseEntity";
import { IApiDocumentRepository } from "../repositories/IApiDocumentRepository";
import { FilterUseCase } from "app/filters/domain/useCase/FilterUseCase";
import { FilterInjection } from "app/filters/di/FilterInjection";
import { FILTER_FEATURE } from "api/ApiPath";
import { CacheKeyEnum } from "utils/enums/CacheKeyEnum";
import { OverviewServiceItem } from "features/generals/domain/entities/overviewServices/OverviewServiceResponseEntity";
import { CreateFileRequestEntity } from "../entities/CreateFileRequestEntity";
import { DeleteFileRequestEntity } from "../entities/DeleteFileRequestEntity";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";

@injectable()
export class ApiDocumentUseCase {
  private repo: IApiDocumentRepository;
  private filterUseCase: FilterUseCase;

  constructor() {
    this.repo = ApiDocumentInjection.getRepo();
    this.filterUseCase = FilterInjection.getUseCase();
  }

  private checkParams(params: ApiDocumentRequestEntity): ApiDocumentRequestEntity {
    return {
      ...params,
    };
  }

  async getApiDocuments(
    params: ApiDocumentRequestEntity
  ): Promise<ListBaseApiResponseModel<ApiDocumentResponseEntity>> {
    return this.repo.getDocuments(this.checkParams(params));
  }

  async getServiceList(): Promise<Array<OverviewServiceItem>> {
    return (await this.filterUseCase.fetchListWithFeature({
      path: FILTER_FEATURE.SERVICE_LIST,
      isNeedFeature: true,
      savedKey: CacheKeyEnum.serviceList,
      params: {},
    })) || [];
  }

  async createFile(
    params: CreateFileRequestEntity
  ): Promise<BaseApiResponseModel<ApiDocumentResponseEntity>> {
    return this.repo.createFile(params);
  }

  async deleteFile(
    params: DeleteFileRequestEntity
  ): Promise<BaseApiResponseModel<unknown>> {
    return this.repo.deleteFile(params);
  }
}

